"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIMediaObject = _interopRequireDefault(require("../layout/UIMediaObject"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _FieldsetContext = require("../context/FieldsetContext");

var _devWarnings = require("../utils/devWarnings");

var LABEL_SIZE_OPTIONS = {
  default: '',
  small: 'private-input-static-label--small'
};

var getStyledLabelWrapper = function getStyledLabelWrapper(Component, className) {
  return (0, _styledComponents.default)(Component).attrs({
    className: className
  }).withConfig({
    displayName: "UIInputStaticLabel",
    componentId: "sc-16nrwnk-0"
  })(["max-width:50%;"]);
};

var UIInputStaticLabel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UIInputStaticLabel, _React$Component);

  function UIInputStaticLabel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIInputStaticLabel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIInputStaticLabel).call(this, props));
    _this._getStyledLabelWrapper = (0, _memoizeOne.default)(getStyledLabelWrapper);
    return _this;
  }

  (0, _createClass2.default)(UIInputStaticLabel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          id = _this$props.id,
          labelWrapperClassName = _this$props.labelWrapperClassName,
          MediaLeft = _this$props.MediaLeft,
          MediaRight = _this$props.MediaRight,
          position = _this$props.position,
          text = _this$props.text,
          error = _this$props.error,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "id", "labelWrapperClassName", "MediaLeft", "MediaRight", "position", "text", "error"]);
      return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref) {
        var fieldSize = _ref.size;
        var computedClassName = (0, _classnames.default)('private-input-static-label', className, LABEL_SIZE_OPTIONS[fieldSize]);

        var renderedLabel = _react.default.createElement(_UITruncateString.default, {
          useFlex: true,
          className: "private-input-static-label__label"
        }, text);

        var cloneProps = {
          id: children.props.id || id
        }; // avoid "unknown prop" warning when `error` is undefined

        if (error !== undefined) {
          cloneProps.error = error;
        }

        var onlyChild = _react.default.Children.only(children);

        (0, _devWarnings.warnIfFragment)(onlyChild, UIInputStaticLabel.displayName);
        return _react.default.createElement("label", Object.assign({}, rest, {
          className: computedClassName
        }), _react.default.createElement(_UIMediaObject.default, {
          spacing: "extra-small",
          itemLeft: position === 'start' ? renderedLabel : undefined,
          MediaLeft: MediaLeft || _this2._getStyledLabelWrapper(_UIMediaObject.default.defaultProps.MediaLeft, labelWrapperClassName),
          itemRight: position === 'end' ? renderedLabel : undefined,
          MediaRight: MediaRight || _this2._getStyledLabelWrapper(_UIMediaObject.default.defaultProps.MediaRight, labelWrapperClassName)
        }, _react.default.cloneElement(onlyChild, cloneProps)));
      });
    }
  }]);
  return UIInputStaticLabel;
}(_react.default.Component);

UIInputStaticLabel.propTypes = {
  children: _propTypes.default.element.isRequired,
  labelWrapperClassName: _propTypes.default.string,
  MediaLeft: _UIMediaObject.default.propTypes.MediaLeft,
  MediaRight: _UIMediaObject.default.propTypes.MediaRight,
  position: _propTypes.default.oneOf(['start', 'end']).isRequired,
  text: _propTypes.default.node.isRequired,
  error: _propTypes.default.bool
};
UIInputStaticLabel.defaultProps = {
  position: 'start'
};
UIInputStaticLabel.displayName = 'UIInputStaticLabel';
var _default = UIInputStaticLabel;
exports.default = _default;
module.exports = exports.default;